/* eslint-disable */
(($, once) => {
  // Refer to 00-base/00-defaults/_02-breakpoints.scss for Breakpoints details.
  var globalBreakpoint = 945;

  Drupal.behaviors.sidebarToggle = {
    attach(context) {
      $(once('filter-toggle', '.filter-toggle', context)).each(function(){
        $(this).closest('.sidebar-filter').addClass('active');
        $(this).click(function(e){
          e.preventDefault();
          $(this).closest('.sidebar-filter').toggleClass('active');
          $(this).closest('.sidebar-filter').attr("aria-expanded") == "false" ? $(this).closest('.sidebar-filter').attr("aria-expanded", "true") : $(this).closest('.sidebar-filter').attr("aria-expanded", "false");
        });
      });

      var lastSize = $(window).width();
      if (lastSize >= globalBreakpoint) {
        $('.main-sidebar h2').removeClass('sidebar-filters-toggle show');
      } else {
        $('.main-sidebar h2').addClass('sidebar-filters-toggle show');

        $(once('sidebar-filter-toggle', '.sidebar-filters-toggle', context)).click(function(){
          $(this).siblings('.sidebar-filter').toggle();
          $(this).toggleClass('show');
        });
      }

      $(window).on('resize', function(){
        var currentSize = $(window).width();
        if ((currentSize < globalBreakpoint && lastSize < globalBreakpoint) || (currentSize >=globalBreakpoint && lastSize >= globalBreakpoint)) {
          return;
        }
        if (currentSize >= globalBreakpoint) {
          $('.main-sidebar h2').removeClass('sidebar-filters-toggle show');
        } else {
          $('.main-sidebar h2').addClass('sidebar-filters-toggle show');

          $(once('sidebar-filter-toggle', '.sidebar-filters-toggle', context)).click(function(){
            $(this).siblings('.sidebar-filter').toggle();
            $(this).toggleClass('show');
          });
        }
        lastSize = currentSize;
      });
    },
  };
})(jQuery, once);
